import React, { useState, useEffect } from 'react';
import { api } from './constants';
import { Save } from 'lucide-react';
import { toast } from 'sonner';

const FIELDS = [
  ['commercial_brand', 'Commercial Brand Name'],
  ['legal_company_name', 'Legal Company Name'],
  ['dba_name', 'DBA Name'],
  ['business_address', 'Business Address'],
  ['phone', 'Phone'],
  ['whatsapp', 'WhatsApp Number'],
  ['email', 'Email'],
  ['license_info', 'License Information'],
  ['qualifier', 'Qualifier'],
];

const TEXTAREAS = [
  ['legal_disclaimer', 'Legal Disclaimer'],
  ['emergency_response_message', 'Emergency Response Message'],
  ['content_en', 'English Content (custom)'],
  ['content_es', 'Spanish Content (custom)'],
];

export default function SettingsPanel() {
  const [s, setS] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get('/settings').then(r => r.json()).then(setS); }, []);

  const save = async () => {
    setSaving(true);
    const put = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/settings`, {
      method: 'PUT', headers: { 'Content-Type': 'application/json' }, credentials: 'include', body: JSON.stringify(s),
    });
    setSaving(false);
    if (put.ok) toast.success('Settings saved');
    else if (put.status === 403) toast.error('Admin access required');
    else toast.error('Save failed');
  };

  if (!s) return <div className="text-slate-400">Loading settings...</div>;
  const inputCls = 'w-full bg-slate-900 border border-slate-700 rounded px-3 py-2 text-white text-sm focus:border-orange-500/50 focus:outline-none';

  return (
    <div className="max-w-3xl" data-testid="settings-panel">
      <h2 className="text-lg font-semibold text-white mb-4">Business Settings</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        {FIELDS.map(([k, label]) => (
          <div key={k}>
            <label className="text-slate-500 text-xs mb-1 block">{label}</label>
            <input data-testid={`setting-${k}`} className={inputCls} value={s[k] || ''} onChange={e => setS(p => ({ ...p, [k]: e.target.value }))} />
          </div>
        ))}
      </div>
      <div className="space-y-4">
        {TEXTAREAS.map(([k, label]) => (
          <div key={k}>
            <label className="text-slate-500 text-xs mb-1 block">{label}</label>
            <textarea rows={2} className={`${inputCls} resize-none`} value={s[k] || ''} onChange={e => setS(p => ({ ...p, [k]: e.target.value }))} />
          </div>
        ))}
      </div>
      <button onClick={save} disabled={saving} data-testid="save-settings-btn" className="mt-5 flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white text-sm font-semibold px-5 py-2.5 rounded disabled:opacity-50"><Save className="w-4 h-4" />Save Settings</button>
    </div>
  );
}
